export default __webpack_public_path__ + "static/media/contractor_marketplace.ce13d365.png";